<div class="cont-country">
    <a class="color-blue country-name" routerLink="/cuenta/perfil" id="nav-bar-country-redirect">
        <img class="image" src="/assets/{{countrySelected.routeImg}}" alt="Profile Icon"> {{countrySelected.countryName}}
        <app-icons [color]="'#418fde'"></app-icons>
    </a>
</div>

<div class="tooltip-ftd">
    <div class="triangle"></div>
    <ul>
        <li *ngFor="let country of countries" (click)="changeCountry(country)" id="nav-bar-menu-country-{{country.cctld}}"><strong> <img class="image" src="/assets/{{country.routeImg}}" alt="Country Icon">{{country.countryName}}</strong></li>
    </ul>
</div>
 